import z from "zod";
import {
  booleanOperatorSchema,
  dateOperatorSchema,
  stringOperatorSchema,
} from "../operations/operation-filter";

export const filterDownloadSchema = z.object({
  userId: stringOperatorSchema.optional(),
  userName: stringOperatorSchema.optional(),
  userEmail: stringOperatorSchema.optional(),
  date: dateOperatorSchema.optional(),
  status: booleanOperatorSchema.optional(),
});

export type FilterDownloadType = z.infer<typeof filterDownloadSchema>;
